'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaddingBoxStyled = undefined;

var _templateObject = _taggedTemplateLiteral(['\n          padding-left: ', ';\n          padding-right: ', ';\n        '], ['\n          padding-left: ', ';\n          padding-right: ', ';\n        ']),
    _templateObject2 = _taggedTemplateLiteral(['\n          padding-top: ', ';\n          padding-bottom: ', ';\n        '], ['\n          padding-top: ', ';\n          padding-bottom: ', ';\n        ']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var propTypes = {
  /** Set padding size*/
  paddingSize: _propTypes2.default.oneOf(['small', 'medium', 'large']),

  /** Remove corresponding paddings */
  removePadding: _propTypes2.default.oneOf(['none', 'horizontal', 'vertical']),

  /** Container will occupy all available space */
  spread: _propTypes2.default.bool,

  /**
   * Define component theme config
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};
var defaultProps = {
  paddingSize: 'small',
  removePadding: 'none',
  spread: false
};
/** PROP RECEIVERS */

var padding = function padding(_ref) {
  var paddingSize = _ref.paddingSize,
      removePadding = _ref.removePadding,
      themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var source = theme.reactackle.components.grid.paddingBox[paddingSize];
  var breakpoints = source.breakpoints;
  var pxScale = removePadding !== 'horizontal' && breakpoints.map(function (item) {
    return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.media)(item.breakpoint)(_templateObject, (0, _reactackleCore.getValueString)(item.paddingX), (0, _reactackleCore.getValueString)(item.paddingX)));
  });
  var px = removePadding !== 'horizontal' ? (0, _styledComponents.css)(['padding-left:', ';padding-right:', ';', ''], (0, _reactackleCore.getValueString)(source.paddingX), (0, _reactackleCore.getValueString)(source.paddingX), pxScale) : '\n      padding-left: 0;  \n      padding-right: 0;  \n    ';
  var pyScale = removePadding !== 'vertical' && breakpoints.map(function (item) {
    return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.media)(item.breakpoint)(_templateObject2, (0, _reactackleCore.getValueString)(item.paddingY), (0, _reactackleCore.getValueString)(item.paddingY)));
  });
  var py = removePadding !== 'vertical' ? (0, _styledComponents.css)(['padding-top:', ';padding-bottom:', ';', ''], (0, _reactackleCore.getValueString)(source.paddingY), (0, _reactackleCore.getValueString)(source.paddingY), pyScale) : '\n        padding-top: 0;\n        padding-bottom: 0;\n      ';
  return (0, _styledComponents.css)(['', ' ', ''], px, py);
};

var spread = function spread(_ref2) {
  var spread = _ref2.spread;
  return spread && 'flex-grow: 1;';
};

var base = function base(_ref3) {
  var themeFromProvider = _ref3.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
  return '\n    font-family: ' + fontFamily + ';\n    box-sizing: border-box;\n  ';
};
/** STYLES */


var PaddingBoxStyled = exports.PaddingBoxStyled = _styledComponents2.default.div.withConfig({
  displayName: 'PaddingBoxStyled'
})(['', ' ', ' ', ' ', ';'], (0, _reactackleCore.transition)('padding'), base, padding, spread);

PaddingBoxStyled.propTypes = propTypes;
PaddingBoxStyled.defaultProps = defaultProps;
PaddingBoxStyled.displayName = 'PaddingBoxStyled';